import React from 'react';
import { Separator } from '@/components/ui/separator';

export const PageHeader = ({ title, subtitle, actions, eyebrow }) => {
  return (
    <div className="mb-6">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div className="min-w-0">
          {eyebrow ? (
            <div className="text-[11px] font-medium uppercase tracking-[0.22em] text-muted-foreground mb-1">
              {eyebrow}
            </div>
          ) : null}
          <h1
            className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground"
            data-testid="page-title"
          >
            {title}
          </h1>
          {subtitle ? (
            <p
              className="mt-1.5 text-sm sm:text-[15px] text-muted-foreground max-w-2xl"
              data-testid="page-subtitle"
            >
              {subtitle}
            </p>
          ) : null}
        </div>
        {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
      </div>
      <Separator className="mt-5 bg-border" />
    </div>
  );
};

export default PageHeader;
